import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import style from './print-modal-content.module.less';
import { PrinterHints } from './printer-hints';
import { PrinterSelector } from './printer-selector';
import { emptyArray } from 'ui-components/default-props/empty';

export const ShipStationPrint = ({
  printers = emptyArray,
  printDestination,
  setPrintDestination,
  hasInstalledShipStationConnect = false,
}) => {
  const hasNoOnlineWorkstations = printers.reduce((hasNoOnline, printerGroup) => {
    return hasNoOnline && !printerGroup.workstationIsOnline;
  }, true);

  return (
    <div className={style['connect-section']}>
      <div className={style['second-level-heading']}>
        <FormattedMessage defaultMessage='Print through ShipStation Connect' description='printModal.printThroughShipStation' id='zDsboC' />
      </div>
      <PrinterSelector
        availablePrinters={printers}
        disabled={hasNoOnlineWorkstations}
        onPrinterSelected={setPrintDestination}
        selectedPrinter={printDestination}
      />
      <PrinterHints availablePrinters={printers} hasInstalledShipStationConnect={hasInstalledShipStationConnect} />
    </div>
  );
};

ShipStationPrint.propTypes = {
  printDestination: PropTypes.object,
  setPrintDestination: PropTypes.func.isRequired,
  printers: PropTypes.arrayOf(
    PropTypes.shape({
      workstationId: PropTypes.string,
      workstationIsOnline: PropTypes.bool,
      workstationName: PropTypes.string,

      printers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          workstationId: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    }),
  ),
  hasInstalledShipStationConnect: PropTypes.bool,
};
